import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { Button, Icon, IconButton, Tooltip } from '@material-ui/core';
import Loader from '../loader/Loader';
import FileExcelIcon from 'mdi-react/FileExcelIcon';
import FilePdfIcon from 'mdi-react/FilePdfIcon';
import GridToolbarFilters from './grid-toolbar-filters';
import GridToolbarSettings from './grid-toolbar-settings';
import GridToolbarColumns from './grid-toolbar-columns';
import classnames from 'classnames';

var isGridButtonDisabled = function isGridButtonDisabled(button, selected) {
  if (button.disabledFunc) {
    return button.disabledFunc(selected);
  }

  return button.onlySelected && !selected;
};

var GridToolbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridToolbar, _React$Component);

  function GridToolbar() {
    var _this;

    _classCallCheck(this, GridToolbar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridToolbar).apply(this, arguments));

    _this.exportXls = function () {
      var exportXlsx = _this.props.exportXlsx;

      if (typeof exportXlsx === 'function') {
        exportXlsx();
      }
    };

    _this.exportPdf = function () {
      var exportPdf = _this.props.exportPdf;

      if (typeof exportPdf === 'function') {
        exportPdf();
      }
    };

    return _this;
  }

  _createClass(GridToolbar, [{
    key: "renderButtons",
    value: function renderButtons() {
      var _this$props = this.props,
          title = _this$props.title,
          buttons = _this$props.buttons,
          selected = _this$props.selected,
          classes = _this$props.classes,
          slim = _this$props.slim;

      if (buttons && buttons.length) {
        return buttons.map(function (button, index) {
          var disabled = isGridButtonDisabled(button, selected);
          return React.createElement(Button, {
            key: "toolbar-button-".concat(index),
            color: button.color || 'primary',
            variant: 'contained',
            size: button.size || 'small',
            className: classnames(_defineProperty({}, classes.toolbarButtonSlim, slim)),
            onClick: button.func,
            disabled: disabled,
            startIcon: button.icon ? React.createElement(Icon, {
              fontSize: 'small'
            }, button.icon) : undefined
          }, button.label);
        });
      }

      return title || '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          filter = _this$props2.filter,
          listFilters = _this$props2.listFilters,
          onChangeListFilters = _this$props2.onChangeListFilters,
          listSettings = _this$props2.listSettings,
          onChangeListSettings = _this$props2.onChangeListSettings,
          columns = _this$props2.columns,
          onChangeColumns = _this$props2.onChangeColumns,
          exportXlsx = _this$props2.exportXlsx,
          exportPdf = _this$props2.exportPdf,
          exportXlsxProgress = _this$props2.exportXlsxProgress,
          exportPdfProgress = _this$props2.exportPdfProgress,
          onChangeFilter = _this$props2.onChangeFilter,
          onChangeFilterFromStorage = _this$props2.onChangeFilterFromStorage,
          onChangeSettingsFromStorage = _this$props2.onChangeSettingsFromStorage,
          onResetSettings = _this$props2.onResetSettings,
          order = _this$props2.order,
          rowsPerPage = _this$props2.rowsPerPage,
          hideFilter = _this$props2.hideFilter,
          filtersMenu = _this$props2.filtersMenu,
          settingsMenu = _this$props2.settingsMenu,
          columnsMenu = _this$props2.columnsMenu,
          slim = _this$props2.slim;
      return React.createElement("div", {
        className: classnames(classes.toolbar, _defineProperty({}, classes.toolbarSlim, slim))
      }, React.createElement("div", {
        className: classnames(classes.toolbarTitle, _defineProperty({}, classes.toolbarTitleSlim, slim))
      }, this.renderButtons()), React.createElement("div", {
        className: classes.toolbarActions
      }, filtersMenu && React.createElement(React.Fragment, null, !hideFilter && React.createElement(GridToolbarFilters, {
        classes: classes,
        filter: filter,
        listFilters: listFilters,
        onChangeListFilters: onChangeListFilters,
        onChangeFilter: onChangeFilter,
        onChangeFilterFromStorage: onChangeFilterFromStorage
      })), settingsMenu && React.createElement(GridToolbarSettings, {
        classes: classes,
        columns: columns,
        order: order,
        rowsPerPage: rowsPerPage,
        listSettings: listSettings,
        onChangeListSettings: onChangeListSettings,
        onChangeSettingsFromStorage: onChangeSettingsFromStorage,
        onResetSettings: onResetSettings
      }), columnsMenu && React.createElement(GridToolbarColumns, {
        classes: classes,
        columns: columns,
        onChangeColumns: onChangeColumns
      }), !!exportXlsx && React.createElement(React.Fragment, null, exportXlsxProgress && React.createElement(Tooltip, {
        title: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442...",
        disableFocusListener: true,
        disableTouchListener: true
      }, React.createElement(IconButton, {
        className: classes.toolbarActionButton,
        color: 'inherit',
        size: 'small'
      }, React.createElement(Loader, {
        size: 18
      }))), !exportXlsxProgress && React.createElement(Tooltip, {
        title: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 XLSX",
        disableFocusListener: true,
        disableTouchListener: true
      }, React.createElement(IconButton, {
        className: classes.toolbarActionButton,
        color: 'inherit',
        size: 'small',
        onClick: this.exportXls
      }, React.createElement(FileExcelIcon, {
        size: 18
      })))), !!exportPdf && React.createElement(React.Fragment, null, exportPdfProgress && React.createElement(Tooltip, {
        title: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442...",
        disableFocusListener: true,
        disableTouchListener: true
      }, React.createElement(IconButton, {
        className: classes.toolbarActionButton,
        color: 'inherit',
        size: 'small'
      }, React.createElement(Loader, {
        size: 18
      }))), !exportPdfProgress && React.createElement(Tooltip, {
        title: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 PDF",
        disableFocusListener: true,
        disableTouchListener: true
      }, React.createElement(IconButton, {
        className: classes.toolbarActionButton,
        color: 'inherit',
        size: 'small',
        onClick: this.exportPdf
      }, React.createElement(FilePdfIcon, {
        size: 18
      }))))));
    }
  }]);

  return GridToolbar;
}(React.Component);

export default GridToolbar;